module.exports = __webpack_public_path__ + "img/jx3box_qqbot_bottom.7c918dda.svg";